import { apiFetch } from '@/lib/api-client';

// Favoris ⭐. Le marquage est TOUJOURS le sien : le serveur prend l'identité dans le jeton, aucun
// identifiant d'utilisateur ne transite ici. Consulter la liste d'un collègue passe par le paramètre
// `favoritesOwnerId` de la file, jamais par ces deux appels.

export function addFavorite(ticketId: string) {
  return apiFetch<{ data: { ticketId: string; createdAt: string } }>('/favorites', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ticketId }),
  });
}

export function removeFavorite(ticketId: string) {
  return apiFetch<{ data: { ok: true } }>(`/favorites/${encodeURIComponent(ticketId)}`, { method: 'DELETE' });
}

/** Les personnes dont on peut consulter les favoris (internes actifs, identité d'affichage seule). */
export function fetchFavoriteUsers() {
  return apiFetch<{ data: { id: string; displayName: string }[] }>('/favorites/users');
}
